<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col md="12" xl="12" lg="12" sm="12">
        <v-container fluid>
          <v-row no-gutters>
            <v-col cols="12">
              <v-container fluid>
                <v-row no-gutters>
                  <v-col  cols="12" sm="12" lg="1" md="1" align-self="center">
                    <v-btn @click="wyszukiwanie_wizyt_popup=true"><v-icon small>fa-search</v-icon></v-btn>
                  </v-col>
                  <v-col cols="12" sm="12" lg="2" md="2" v-if="(dostepnePlacowki != null && dostepnePlacowki.length > 0)">
                    <v-select v-if="(dostepnePlacowki != null && dostepnePlacowki.length > 0)" placeholder="Wybierz placówkę..." label="Placówka" :items="dostepnePlacowki" return-object v-model="wybranaPlacowka" item-text="name"></v-select>
                  </v-col>
                  <v-col cols="12"  sm="12" lg="2" md="2" align-self="center" class="ml-10">
                    <v-autocomplete placeholder="Wybierz terapeute..." label="Terapeuta" :items="dostepniTerapeuci" return-object v-model="wybranyTerapeuta" :clearable="!settings.forceCalendarToOneTherapist" item-text="fullName">
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" lg="1"  md="1" align-self="center">
                    <v-btn  icon @click="PokazujWszystkichPracownikow();" class="ml-4" title="Pokazuj wszystkich pracownikow - widok dzienny">
                      <v-icon v-if="pokazuj_wszystkich" color="success">fa-eye</v-icon>
                      <v-icon v-if="!pokazuj_wszystkich">fa-eye-slash</v-icon>
                    </v-btn>
                    <v-btn  icon @click="pokazWolneDaty();"  v-if="wolnytermin_dostepny"  class="ml-4" title="Znajdz najbliższy wolny termin">
                      <v-icon color="success">fa-bolt</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="12" lg="2" md="2" v-if="(therapistGroups != null && therapistGroups.length > 0)">
                    <v-select v-if="(therapistGroups != null && therapistGroups.length > 0)" placeholder="Wybierz grupe..." label="Grupa" :items="therapistGroups" return-object v-model="selectedTherapistGroup" item-text="name" clearable></v-select>
                  </v-col>
                  <v-col align-self="center" class="text-center" cols="12" sm="12" lg="2" md="2">
                    <p v-show="smsText" style="color:#1976d2;margin-bottom:0 !important; margin-right:10px;">{{smsText}}. <span v-if="visitsToCheck >0" style="color:red">Ilość wizyt do wyjaśnienia: {{visitsToCheck}}</span> <v-btn fab x-small class="ml-4" @click="showSMSVisits = true" title="Wyszukiwanie sms"><v-icon>fa-search</v-icon></v-btn>
                      <v-badge v-if="unreadSMSCount > 0" :content="unreadSMSCount" color="error" overlap class="ml-4">
                        <v-btn fab x-small @click="goToSMSCenter" title="Nieodczytane SMS">
                          <v-icon color="warning">fa-envelope</v-icon>
                        </v-btn>
                      </v-badge>
                    </p>
                    <p v-show="lastTimeCheckedSMS" style="color:#1976d2;margin-bottom:0 !important; margin-right:10px;">{{lastTimeCheckedSMS}}</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <ejs-schedule height="auto" :startHour="startHour" :endHour="endHour" width="100%" id="Schedule"
                            :selectedDate="selectedDate"
                            :eventSettings='eventSettings' :timeScale="timeScale" :workHours="workHours" :rowAutoHeight="true"  @dataBinding="createScheduler"
                            :popupOpen='onPopupOpen' :firstDayOfWeek="firstDayOfWeek" :eventRendered="oneventRendered" :ownerCollections="therapistsList" :actionBegin="beginAction"  :currentView="currentView"
                            :group="group" cssClass="poko-calendar" @navigating="navigating" @actionComplete="actionComplete"  :resourceHeaderTemplate='resourceTemplate' :dataBound="onDataBound"
                            ref="ScheduleObj" @dragover.native="onDragOver" @dragenter.native="onDragEnter" @dragleave.native="onDragLeave" @drop.native="onDragDrop" :dragStop="onDragStopCalendar" :drag="onDragCalendar"
                            :dragStart="onDragStartCalendar" :allowDragAndDrop="allowDragAndDrop">
                <e-views>
                  <e-view option="Day" :eventTemplate="dayTemplate"></e-view>
                  <e-view option="Week" :eventTemplate="weekTemplate">
                  </e-view>
                  <e-view option="Month"></e-view>
                </e-views>
                <e-resources>
                  <e-resource field="therapistID" title="Terapeuci" :dataSource='therapistsList' allowMultiple="true"
                              name="Terapeuci" textField="therapistName" idField="therapistID" colorField="therapistColor" workDaysField='workDays'  startHourField="startHour" endHourField="endHour">
                  </e-resource>
                </e-resources>
              </ejs-schedule>
              <v-fab-transition>
                <v-btn
                    color="primary"
                    fab
                    large
                    dark
                    top
                    right
                    id="reserve_button"
                    v-if="$can('do','POKO_Rezerwy') && reserveButtonVisible && open_reserves == false"
                    @click="open_reserves = true"
                    title="Pokaż rezerwy"
                >
                  <v-icon>fa-calendar-plus</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <VisitEditor  v-if="showVisitEditor" :visible="showVisitEditor" :visitData="visitData" @close="closeAddPopup" :zabiegi="fullZabiegiList" :typywizyt="typywizyt" :placowka="wybranaPlacowka"/>
    <v-dialog v-model="wyszukiwanie_wizyt_popup" transition="dialog-bottom-transition" persistent width="80%">
      <v-card>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                  <v-tabs
                      grow
                      v-model="active_tab_visits"
                      slider-color="primary"
                  >
                    <v-tab ripple key="0"><v-icon small>fas fa-search</v-icon>Wyszukiwanie wizyt</v-tab>
                    <v-tab-item key="0">
                      <v-card>
                        <v-card-text>
                          <v-container fluid>
                            <v-row no-gutters>
                              <v-col cols="12">
                                <v-autocomplete
                                    v-model="searchClientId"
                                    :loading="isLoadingClients"
                                    :items="clientsList"
                                    :search-input.sync="clientKeyword"
                                    cache-items
                                    flat
                                    no-data-text="Nieznaleziono"
                                    hide-details
                                    clearable
                                    item-text="name"
                                    item-value="id"
                                    prepend-icon="fa-search"
                                    label="Wyszukaj pacjenta Imię/Nazwisko/PESEL"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row no-gutters>
                              <v-col cols="12">
                                <v-autocomplete
                                    v-model="searchTherapistId" :loading="isLoadingTherapists" :items="therapists"
                                    :search-input.sync="therapistKeyword" cache-items flat clearable
                                    no-data-text="Nieznaleziono" hide-details
                                    item-text="name" item-value="id"
                                    prepend-icon="fa-search"
                                    label="Wyszukaj terapeute Imię/Nazwisko"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row no-gutters>
                              <v-col cols="12">
                                <v-form>
                                  <v-container fluid>
                                    <v-row no-gutters>
                                      <v-col cols="6">
                                        <v-menu
                                            v-model="showSearchDate1"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :disabled="searchOnlyIncomming"
                                            transition="scale-transition"
                                            offset-y
                                        >
                                          <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="searchDate1"
                                                label="Data początkowa"
                                                prepend-icon="fa-calendar-alt"
                                                placeholder="Wybierz date"
                                                readonly
                                                v-on="on"
                                            ></v-text-field>
                                          </template>
                                          <v-date-picker v-model="searchDate1" @input="showSearchDate1 = false" :disabled="searchOnlyIncomming"  no-title scrollable locale="pl-PL"></v-date-picker>
                                        </v-menu>
                                      </v-col>
                                      <v-col cols="6">
                                        <v-menu
                                            v-model="showSearchDate2"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :disabled="searchOnlyIncomming"
                                            transition="scale-transition"
                                            offset-y
                                        >
                                          <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="searchDate2"
                                                label="Data końcowa"
                                                prepend-icon="fa-calendar-alt"
                                                placeholder="Wybierz date"
                                                readonly
                                                v-on="on"
                                            ></v-text-field>
                                          </template>
                                          <v-date-picker v-model="searchDate2"  @input="showSearchDate2 = false" :disabled="searchOnlyIncomming"  no-title scrollable locale="pl-PL"></v-date-picker>
                                        </v-menu>
                                      </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                      <v-col cols="12">
                                        <v-checkbox
                                            v-model="searchOnlyIncomming"
                                            label="Tylko nadchodzące wizyty?"
                                        ></v-checkbox>
                                      </v-col>
                                    </v-row>
                                    <v-row no-gutters v-show="searchResultsVisible">
                                      <v-col cols="12">
                                        <v-data-table
                                            :options.sync="pagination"
                                            :items="searchItems"
                                            :loading="searchLoading"
                                            :server-items-length="searchTotalResults"
                                            :no-results-text="noResults"
                                            :no-data-text="noResults"
                                            :footer-props="{itemsPerPageOptions:[20,50,100,200]}"
                                            :headers="headers">
                                          <template v-slot:item.startTime="{item}">
                                            {{ getFormattedDate(item.startTime) }}
                                          </template>
                                          <template v-slot:item.endTime="{item}">
                                            {{ getFormattedDate(item.endTime) }}
                                          </template>
                                          <template v-slot:item.status="{item}">
                                            {{ getStatusDescription(item.status) }}
                                          </template>
                                          <template v-slot:item.id="{item}">
                                            <v-icon small class="mr-2" @click="showEditPopup(item.id)" title="Edytuj wizyte">fa-user-edit</v-icon>
                                          </template>
                                        </v-data-table>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-form>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn @click="resetSearch" color="primary">Reset</v-btn>
                          <v-btn color="success" @click="handleSearch">Szukaj</v-btn>
                          <v-btn color="error" @click="wyszukiwanie_wizyt_popup = false">Zamknij</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

    </v-dialog>

    <v-navigation-drawer
        right
        app
        v-if="open_reserves"
    >

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6">
            Dostępne rezerwy
            <v-btn @click="open_reserves = false" icon color="primary"><v-icon>fa-window-close</v-icon></v-btn>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list
          dense
          nav
          style="overflow-y:auto"
      >
        <v-list-item>
          <v-sheet style="height: 155px">
            <v-text-field label="Imie i nazwisko" prepend-icon="fa-search" v-model="reserve_name"></v-text-field>
            <v-text-field label="Terapeuta" prepend-icon="fa-search" v-model="reserve_name_therapist"></v-text-field>
          </v-sheet>
        </v-list-item>
        <v-list-item
            v-for="item in filteredReserves"
            :key="item.id"
        >
          <v-list-item-content>
            <v-sheet class="reserve-container" :color="item.therapistColor" draggable="true" @dragstart="onDragging($event,item)" @dragend="onDragStop" @dblclick.stop="editReserveReadonly(item.id)">
              <span>{{item.client.name + ' '+item.client.surname}} - <b>{{ getPriority(item.priority) }}</b></span><br/>
              <span>Tel: {{item.client.phone}}</span><br/>
              <span>{{item.therapist.name + ' '+item.therapist.surname}}</span>
              <v-menu open-on-hover left offset-y>
                <template v-slot:activator="{on, attrs}">
                  <v-icon v-on="on" v-bind="attrs" style="position: absolute; top:3px; right: 3px;cursor: default" color="white">fa fa-comment</v-icon>
                </template>
                <v-card width="300px">
                  <v-card-title>{{item.client.name + ' '+item.client.surname}}</v-card-title>
                  <v-card-text>
                    <p>Tel: {{item.client.phone}}</p>
                    <p>{{item.reserve_date_description}}</p>
                    <p>{{item.reserve_hours_description}}</p>
                    <p>{{item.notes}}</p>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-sheet>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <EditReserve v-if="showEditReserve" :readonly="true" :id="selected_reserve_id" :visible="showEditReserve" @close="showEditReserve = false"></EditReserve>
    <SearchSMSVisits :visible="showSMSVisits" v-if="showSMSVisits" @close="showSMSVisits = false"></SearchSMSVisits>
    <v-dialog v-model="therapists_visits_schedules" transition="dialog-bottom-transition" persistent max-width="700px">
      <v-card flat>
        <v-toolbar dark class="primary">
          <v-btn icon @click.native="therapists_visits_schedules = false" dark>
            <v-icon>fa-times</v-icon>
          </v-btn>
          <v-toolbar-title>Dostepne terminy</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <TherapistsVisitsSchedules v-if="therapists_visits_schedules" :therapistid="wybranyTerapeuta.id" @datepicked="onDatePickedTherapistShechedules"></TherapistsVisitsSchedules>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showVisitQuickInfo" transition="dialog-bottom-transition" max-width="700px">
      <v-card>
        <v-toolbar dark class="primary">
          <v-btn icon @click.native="showVisitQuickInfo = false" dark>
            <v-icon>fa-times</v-icon>
          </v-btn>
          <v-toolbar-title>Szczegóły wizyty</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <VisitQuickInfo v-if="showVisitQuickInfo" :visit-id="selectedVisitQuickInfoId" :typywizyt="typywizyt" />
        </v-card-text>
      </v-card>      
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { clientService } from "@/services/";
import { visitService } from "@/services/";
import { therapistsService } from "@/services/";
import Vue from 'vue'

import {DataManager, UrlAdaptor } from "@syncfusion/ej2-data";
import { Day, Week, Month,DragAndDrop } from "@syncfusion/ej2-vue-schedule";
import { DatePickerPlugin} from '@syncfusion/ej2-vue-calendars';
import { authHeader } from "@/helpers";
import { ability } from "@/store/ability";
import * as dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isToday from "dayjs/plugin/isToday"
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import * as helpers from "@/helpers";
import VisitEditor from "./VisitEditor";
import {reserveService, settingsService, zabiegiService} from "@/services";
import swal from "sweetalert";
import EditReserve from "@/components/reserves/EditReserve";
import SearchSMSVisits from "@/components/visits/SearchSMSVisits";
import TherapistsVisitsSchedules from "@/components/visits/TherapistsVisitsSchedules.vue";
import VisitQuickInfo from "@/components/visits/VisitQuickInfo.vue";

class CustomAdaptor extends UrlAdaptor {
  processResponse(data, ds, query, xhr, request, changes) {
    let processedData = [];
    if(changes)

    if (data != null && data.result != null && data.result.items != null) {

      data.result.items.forEach(item => {
        processedData.push({
          Id: item.id,
          Subject: item.clientName,
          StartTime: item.startTime,
          EndTime: item.endTime,
          CategoryColor: item.therapistColor,
          Description: item.therapistName,
          therapistID: item.therapistID,
          State: item.status,
          notes: item.notes,
          payuPaid: item.payuPaid,
          normalPaid: item.normalPaid,
          isFromPortal: item.isFromPortal,
          portalStatus: item.portalStatus
        });
      });
      this.receivedData(data.result.items);
    }

    return processedData;
  }
  processQuery(dm, query, hierarchyFilters) {

    var original = UrlAdaptor.prototype.processQuery;

    let query2 = original.apply(this, [dm, query, hierarchyFilters]);

    return query2;
  }
  beforeSend(dm, request) {

    request.setRequestHeader("Authorization", authHeader().Authorization);
  }
  receivedData() {}
}
var dataManger = new DataManager({
  url: helpers.apiConfig.apiUrl + "/api/services/app/Visit/ListVisits",
  adaptor: new CustomAdaptor(),
  crossDomain: false
});
Vue.use(DatePickerPlugin);

var dayTempVue = Vue.component("dayTemp", {
  template:'<div class="template-wrapper" :style="{background: data.PrimaryColor}">' +
  '<div class="inner-container">' +
    '<div class="subject" :style="{background: data.SecondaryColor, borderColor: data.PrimaryColor}">' +
      '{{data.Subject}} <br v-if="!settings.showNotesOnCalendarEvent"/> {{getTimeString(data.StartTime)}} - {{getTimeString(data.EndTime)}}<br/>' +
      '<p v-if="settings.showNotesOnCalendarEvent" class="wrap-text">{{data.notes}}</p>' +
    '</div>' +
    '<div class="icon-row">' +
    '</div>' +
  '</div>' +
'</div>',
  data() {
    return {
      data: {}
    };
  },
  computed:
  {
    ...mapState('companySettingsModule',['settings'])
  },
  methods: {
    getTimeString: function (value) {
      let dj = dayjs(value)
      return dj.format('HH:mm')
    }
  }
});
var weekTempVue = Vue.component("weekTempVue", {
  template:
     '<div class="template-wrapper" :style="{background: data.PrimaryColor}">'+
      '<div class="inner-container">'+
      '<div class="subject" :style="{background: data.SecondaryColor, borderColor: data.PrimaryColor }" >{{data.Subject}} <br v-if="!settings.showNotesOnCalendarEvent"/> {{getTimeString(data.StartTime)}} - {{getTimeString(data.EndTime)}}<br/><p v-if="settings.showNotesOnCalendarEvent" class="wrap-text" v-html="data.notes"></p></div>'+
      '<div class="icon-row">'+
      '</div>'+
      '</div>'+
      '</div>',
  data() {
    return {
      data: {}
    };
  },
  mounted() {
  },
  computed: {
    ...mapState('companySettingsModule',['settings'])
  },
  methods: {
    getTimeString: function (value) {
      let dj = dayjs(value)
      return dj.format('HH:mm')
    }
  }
});


var terapeutaVue = Vue.component('terapeutaKalendarzVuew', {
  template: '<div class="template-wrapper" :style="{background: data.resourceData.therapistColor}">'+
      '<div style="text-align: center;color:white;padding:5px; word-break: break-all">{{data.resourceData.therapistName}}</div></div>',
      data() {
        return {
          data: {}
        }
      },
});

export default {
  name: "Visits",
  data() {
    return {
      startHour: "06:00",
      endHour: "22:00",
      workHours: {
        highlight: false,
        start: "06:00",
        end: "22:00"
      },
      reserve_name: null,
      reserve_name_therapist: null,
      fullTherapistList: [],
      currentView: 'Week',
      firstDayOfWeek: 1,
      selectedDate: new Date(),
      //datamanager
      eventSettings: { dataSource: [] },
      unsubscribeEvent: null,
      visitData: null,
      showVisitEditor: false,
      therapistsList: [],
      localTherapistsList: [],
      fullEventData: [],
      nearVisits: [],
      currentVisits: [],
      pastVisits: [],
      timerNear: 0,
      timerVisits: 0,
      firstRefresh: false,
      refreshing: false,
      active_tab_visits: 0,
      searchClientId: 0,
      isLoadingClients: false,
      clientsList: [],
      therapists_visits_schedules: false,
      open_reserves: false,
      wolnytermin_dostepny: false,
      wolnytermin: null,
      searchTherapistId: 0,
      isLoadingTherapists: false,
      therapists: [],
      clientKeyword: null,
      therapistKeyword: null,
      showSearchDate1: false,
      showSearchDate2: false,
      searchDate1: null,
      searchDate2: null,
      wyszukiwanie_wizyt_popup: false,
      searchOnlyIncomming: false,
      searchResultsVisible: false,
      searchTotalResults: 0,
      searchLoading: true,
      searchItems: [],
      noResults: "Nie znaleziono danych",
      pagination: {},
      orgPagination: null,
      initialLoad: false,
      showSMSVisits: false,
      currentAdditionalOpenDays: [],
      headers: [
        { text: 'Pacjent', sortable: false, align: 'left', value: 'clientName'},
        { text: 'Terapeuta', sortable: false, align: 'left', value: 'therapistName'},
        { text: 'Początek', sortable: false, align: 'left', value: 'startTime'},
        { text: 'Koniec', sortable: false, align: 'left', value: 'endTime'},
        { text: 'Status', sortable: false, align: 'left', value: 'status'},
        { text: 'Akcje', sortable: false, align: 'left', value: 'id'}
      ],
      dayTemplate: function () {
        return {
          template: dayTempVue
        };
      },
      weekTemplate: function() {
        return {
          template: weekTempVue
        }
      },
      slotCount: 2,   
      slotsNumbers: [2,4,6],
      smsText: '',
      visitsToCheck: 0,
      lastTimeCheckedSMS: null,
      unreadSMSCount: 0,
      smsRefreshInterval: null,
      group_therapist: false,
      calCurrentView: '',
      group: { byGroupID: false, resources: [] },
      resourceTemplate: function () {
        return { template: terapeutaVue }
      },
      wybranyTerapeuta: null,
      pokazuj_wszystkich: false,
      fullZabiegiList: [],
      typywizyt: [],
      isLayoutChanged: false,
      reserveButtonVisible: false,
      reserves: [],
      draggedItem: null,
      showEditReserve: false,
      selected_reserve_id: 0,
      allowDragAndDrop: false,
      dragStartData: null,
      wybranaPlacowka: null,
      therapistGroups: [],
      selectedTherapistGroup: null,
      showVisitQuickInfo: false,
      selectedVisitQuickInfoId: null
    };

  },
  computed: {
    ...mapState("visits", ["noBlinkVisits"]),
    ...mapState('featuresModule',['features']),
    ...mapState('companySettingsModule',['settings']),

    timeScale: function() {
      let interval = 30
      if(this.settings.calendarTimeScale > 0)
      {
        interval = this.settings.calendarTimeScale
      }
      return {
        enable: true,
        interval: 60,
        slotCount: 60/interval,
        majorSlotTemplate: null,
        minorSlotTemplate: null

      }
    },
    isSmsEnabled: function() {
      return this.features && (this.features.SendSMS  || this.features.AndroidSMS)
    },
    isFizykoTerapiaEnabled: function() {
      return this.features && this.features.Fizykoterapia
    },

    dostepniTerapeuci: function() {
      let ret = []
      if(this.fullTherapistList && this.dostepnePlacowki && this.dostepnePlacowki.length > 0 && this.wybranaPlacowka)
      {
        this.fullTherapistList.forEach(elem => {

          if(elem.additionalOutposts && elem.additionalOutposts.length > 0)
          {
            if(elem.additionalOutposts.indexOf(this.wybranaPlacowka.id) >= 0) {
              ret.push(elem)
            }
          }
          else
          {
            ret.push(elem)
          }
        })
      }
      else if (this.fullTherapistList)
      {
        ret = this.fullTherapistList
      }
      let filtrPracownikowRet = []

      if(this.selectedTherapistGroup != null)
      {
        ret.forEach(elem => {
          if(elem.therapistGroupID == this.selectedTherapistGroup.id)
          {
            filtrPracownikowRet.push(elem)
          }
        })
        return filtrPracownikowRet
      }
      return ret
    },
    dostepnePlacowki: function() {
      let placowki = []

      let userDetails = this.$store.state.account.userdetails

      if(this.settings.additionalOutposts && this.settings.additionalOutposts.length > 0)
      {
        this.settings.additionalOutposts.forEach(elem => {
          if(userDetails != null && userDetails.additionalOutposts && (userDetails.additionalOutposts.length == 0 || userDetails.additionalOutposts.indexOf(elem.id) != -1))
            placowki.push(elem)
        })
      }
      return placowki
    },
    filteredReserves: function() {
      let filtered = []
      let appliedFilter = false
      if(this.reserve_name && this.reserve_name.length > 0)
      {
       // console.log(this.reserve_name.toLowerCase())
        filtered = this.reserves.filter(elem=> (elem.client.name + ' '+elem.client.surname).toLowerCase().indexOf(this.reserve_name.toLowerCase()) > -1)
        appliedFilter = true
      }
      if(this.reserve_name_therapist && this.reserve_name_therapist.length > 0)
      {
        if(appliedFilter)
          filtered = filtered.filter(elem=> (elem.therapist.name + ' '+elem.therapist.surname).toLowerCase().indexOf(this.reserve_name_therapist.toLowerCase()) > -1)
        else
          filtered = this.reserves.filter(elem=> (elem.therapist.name + ' '+elem.therapist.surname).toLowerCase().indexOf(this.reserve_name_therapist.toLowerCase()) > -1)

        appliedFilter = true
      }
      if(appliedFilter)
        return filtered

      return this.reserves
    }
  },
  methods: {
    ...mapActions("title", ["updateTitle"]),
    ...mapActions("alert", ["error", "success"]),
    ...mapActions("visits", ["saveNoBlinkVisits"]),
    ...mapActions("therapistListModule", ["setTherapists"]),
    onContextMenu(args) {

    },
    getTherapistGroups() {
      therapistsService.getTherapistGroups().then(response => {
        if (response.data.result) {
          this.therapistGroups = response.data.result;
        }
      }).catch(err => {
        if(err.response != null && err.response.data != null && err.response.data.error != null)
        {
          this.showError(err.response.data.error.message)
        }
        else
        {
          this.showError('Błąd pobierania grup terapeutów')
        }
      })
    },
    onDragCalendar(args)
    {
      //console.log(args)
    },
    onDragStartCalendar(args)
    {
      this.dragStartData = args;
    },
    onDatePickedTherapistShechedules(item)
    {
      this.therapists_visits_schedules = false
      this.ShowPopup(item)
    },
    onDragStopCalendar(args)
    {
      if(this.allowDragAndDrop == true) {
        if(args.data == null || this.dragStartData == null) {
          args.cancel = true
          return
        }
        let scheduleObj = this.$refs.ScheduleObj;
        if(args.data.therapistID !== this.dragStartData.data.therapistID || args.data.isBlock) {
          this.dragStartData = null
          args.cancel = true
          return
        }
        let cellData = scheduleObj.getCellDetails(args.target)
        if(cellData == null)
        {
          args.cancel = true
          this.dragStartData = null
          return
        }
        let calResourceData = scheduleObj.getResourcesByIndex(cellData.groupIndex)

        if(calResourceData == null)
        {
          args.cancel = true
          this.dragStartData = null
          return
        }


        visitService.shiftVisit({
          visitId: args.data.Id,
          startTime: args.data.StartTime,
          endTime: args.data.EndTime
        }).then(() => {
          this.dragStartData = null
          this.refreshData()
        }).catch((err) => {
          if(err.response != null && err.response.data != null && err.response.data.error != null)
          {
            this.showError(err.response.data.error.message)
          }
          else
          {
            this.showError('Przełożenia wizyty')
          }
          this.refreshData()
          this.dragStartData = null
        })
      }
    },
    showError( text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {

      });
    },
    onDragOver(event)
    {
      let toElement = event.toElement

      if(toElement.classList.value.indexOf('e-work-hours') > -1)
      {
        event.preventDefault()
        event.dataTransfer.dropEffect = 'move';
      }
      //.e-work-cells.e-work-hours
      return false;

    },
    editReserveReadonly(id)
    {
      this.selected_reserve_id = id
      this.showEditReserve  = true
    },
    onDragEnter(event)
    {
      let toElement = event.toElement
      if(toElement.classList.value.indexOf('e-work-hours') > -1)
      {
        event.preventDefault()
        if(toElement.classList.value.indexOf('hover') == -1)
        {
          toElement.classList.add('hover')
        }
      }
      //.e-work-cells.e-work-hours
      return false;
    },
    onDragLeave(event)
    {
      let toElement = event.toElement
      if(toElement.classList.value.indexOf('e-work-hours') > -1)
      {
        event.preventDefault()
        event.dataTransfer.dropEffect = 'move';
        if(toElement.classList.value.indexOf('hover') > -1)
        {
          toElement.classList.remove('hover')
        }
      }
      //.e-work-cells.e-work-hours
      return false;
    },
    onDragging(event,item)
    {
      this.draggedItem = item
      event.dataTransfer.setData('text', 'Dragme');
      event.dataTransfer.effectAllowed = 'move';
      event.toElement.style.cursor = 'move';
      //event.toElement.style.pointerEvents = "none"
    },
    onDragDrop(event)
    {
      let toElement = event.toElement
      if(toElement.classList.value.indexOf('e-work-hours') > -1)
      {
        event.preventDefault()
        event.dataTransfer.dropEffect = 'move';
        if(toElement.classList.value.indexOf('hover') > -1)
        {
          toElement.classList.remove('hover')
          let isScheduleSlot = toElement.getAttribute('role')
          if(isScheduleSlot != null && isScheduleSlot == 'gridcell')
          {
            let scheduleObj = this.$refs.ScheduleObj;
            let cellData = scheduleObj.getCellDetails(toElement)
            let calResourceData = scheduleObj.getResourcesByIndex(cellData.groupIndex)
            //cellData.groupIndex
            let argsData = {}
            let reserve = this.draggedItem
            argsData.StartTime = cellData.startTime

            let newDate = new dayjs(cellData.startTime).add(reserve.visit_time,'minute')
            argsData.EndTime = newDate.toDate()
            argsData.therapistID = reserve.therapist.id
            argsData.reserveId = reserve.id
            argsData.type = 'Day'
            argsData.client = reserve.client
            if(reserve.therapistVisitType != null)
            {
              argsData.typWizytyTerapeutyId = reserve.therapistVisitType.id
            }
            if(calResourceData.resourceData.therapistID != reserve.therapist.id)
            {
              argsData.therapistID = calResourceData.resourceData.therapistID
              swal({
                title: "Czy na pewno?",
                text: "Ta rezerwa jest zarejestrowana na innego terapeute, czy na pewno chcesz kontynuować?",
                icon: "warning",
                buttons: ["Nie", "Tak"],
                dangerMode: true
              }).then(confirmed => {
                if (confirmed) {
                  this.ShowPopup(argsData)
                }
              });
            }
            else {
              this.ShowPopup(argsData)
            }
            this.draggedItem = null

          }
        }
      }
      //.e-work-cells.e-work-hours
      return false;
    },
    getCurrentTarget(e)
    {
      if (e.toElement) {
        return e.toElement;
      } else if (e.currentTarget) {
        return e.currentTarget;
      } else if (e.srcElement) {
        return e.srcElement;
      } else {
        return null;
      }
    },
    onDragStop(event)
    {
      var target = this.getCurrentTarget(event);
      target.style.cursor = 'default';
    },
    getPriority(priority)
    {
      switch(priority)
      {
        case 0:
          return 'NOR';
        case 1:
          return 'TER';
        case 2:
          return 'VIP';
      }
      return 'NORMALNY';
    },
    getAllTypyWizyt() {
      therapistsService.GetWszystkieTypyWizyt().then(result => {
        this.typywizyt = result.data.result
      }).catch(() => {
        this.error("Nie można pobrać typów wizyt terapeutów.");
      })
    },
    getAllZabiegi() {
      if(this.isFizykoTerapiaEnabled) {
        zabiegiService
            .getZabiegiList()
            .then(response => {
              if (
                  response.data != null &&
                  response.data.result != null
              ) {
                this.fullZabiegiList = response.data.result
              } else {
                throw "error pobierania terapeutów";
              }
            })
            .catch(e => {
              console.log(e)
              this.isLoadingTherapists = false;
              this.error("Nie można pobrać listy zabiegów.");
            });
      }
    },
    PokazujWszystkichPracownikow() {

      this.pokazuj_wszystkich = !this.pokazuj_wszystkich
      if(this.calCurrentView == 'Day')
      {
        this.refreshData()
      }
    },
    beginAction(args) {

    },
    onDataBound(args) {
      let scheduleObj = this.$refs.ScheduleObj.ej2Instances;
      if (this.calCurrentView == 'Day') {
        let renderedDates = scheduleObj.activeView.getRenderDates();
        scheduleObj.resetWorkHours();

          let dayIndex = renderedDates[0].getDay();


          for(let i =0; i < this.therapistsList.length; i++){
            let elem = this.therapistsList[i].therapistID

            let foundTherapist = this.fullTherapistList.find(x=>x.userId == elem)
            if(foundTherapist && foundTherapist.schedules) {
              let schedule = foundTherapist.schedules.find(x=>x.isEnabled && x.day == dayIndex)
              if(schedule) {
                scheduleObj.setWorkHours([renderedDates[0]], schedule.startHour, schedule.endHour, i)
              }
            }
            if(this.currentAdditionalOpenDays && this.currentAdditionalOpenDays.length > 0 && foundTherapist) {

              let foundTherapistAdditionalDay = this.currentAdditionalOpenDays.find(x=>x.therapistID == foundTherapist.therapistID)
              if(foundTherapistAdditionalDay)
              {
                let startTime = dayjs(foundTherapistAdditionalDay.timeStart,'HH:mm:ss').format("HH:mm")
                let endTime = dayjs(foundTherapistAdditionalDay.timeEnd,'HH:mm:ss').format("HH:mm")
                scheduleObj.setWorkHours([renderedDates[0]], startTime, endTime, i)
              }
            }
          }
      }
      else
      {
        scheduleObj.resetWorkHours();
        if(this.wybranyTerapeuta != null)
        {

          let renderedDates = scheduleObj.activeView.getRenderDates();
          if(this.wybranyTerapeuta.schedules != null)
          {
            for(let i =0; i< renderedDates.length; i++)
            {
              let dayIndex = renderedDates[i].getDay()
              let schedule = this.wybranyTerapeuta.schedules.find(x=>x.isEnabled && x.day == dayIndex)
              if(schedule) {
                scheduleObj.setWorkHours([renderedDates[i]], schedule.startHour, schedule.endHour)

              }
            }
            if(this.currentAdditionalOpenDays && this.currentAdditionalOpenDays.length > 0)
            {
                let itemsForTherapist = this.currentAdditionalOpenDays.filter(x=>x.therapistID == this.wybranyTerapeuta.therapistID)
                if(itemsForTherapist && itemsForTherapist.length > 0) {
                  itemsForTherapist.forEach(elem=> {
                    for (let i = 0; i < renderedDates.length; i++) {
                      let d = dayjs(renderedDates[i])
                      let start = dayjs(elem.start)
                      let end = dayjs(elem.end)

                      if(d.isBetween(start.format('YYYY-MM-DD'), end.format("YYYY-MM-DD"),'day','[]')) {
                        let startTime = dayjs(elem.timeStart,'HH:mm:ss').format("HH:mm")
                        let endTime = dayjs(elem.timeEnd,'HH:mm:ss').format("HH:mm")
                        scheduleObj.setWorkHours([renderedDates[i]], startTime, endTime)
                      }
                    }
                  })
                }
            }
          }

        }
      }
      this.refreshBlinkClasses()
    },
    actionComplete(args) {

      if(args.requestType && args.requestType == 'viewNavigate')
      {
        this.refreshData()
        this.isLayoutChanged = true
      }
      if(args.requestType && args.requestType == 'dateNavigate')
      {
        this.refreshData()
        this.isLayoutChanged = true
      }
    },
    createScheduler()
    {
      if(!this.initialLoad)
      {
        this.initialLoad = true
        this.refreshData()
        return
      }
      //console.log(args)
      //
      //this.eventSettings = {dataSource: [] }
    },
    onPopupOpen(args) {
      let type = this.calCurrentView
      if(this.wybranyTerapeuta != null) {
        type = 'Day'
        args.data.therapistID = this.wybranyTerapeuta.id
      }
      if(args.data.isBlock)
      {
        args.cancel = true;
        return
      }
      let obj = {...args.data, type: type }
      this.ShowPopup(obj);
      args.cancel = true;
    },
    ShowPopup(data) {
      /*  let fn = this.$store.subscribe((mutation, state) => {
          /*console.log(mutation.payload);*/
      /*});
      this.unsubscribeEvent = fn;*/
      this.visitData = data;
      this.showVisitEditor = true;

    },
    showEditPopup(id) {
      this.ShowPopup({ Id: id });
    },
    resetSearch() {
      this.searchClientId = 0
      this.searchTherapistId = 0
      this.searchLoading = false
      this.searchDate1 = null
      this.searchDate2 = null
      this.pagination = {}
      this.searchItems = []
      this.searchOnlyIncomming = false
      this.searchTotalResults = 0
      this.searchResultsVisible = false
      this.pagination = {...this.orgPagination}
      this.active_tab_visits = 0
      this.refreshData()
    },
    getFormattedDate(val)
    {
      let dj = dayjs(val)
      if(dj != null)
      {
        return dj.format("DD-MM-YYYY HH:mm")
      }
      else
      {
        return val
      }
    },
    getStatusDescription(status)
    {
      switch(status)
      {
        case 0:
          return 'Nowa'
        case 1:
          return 'Potwierdzona'
        case 2:
          return 'Anulowana'
        case 3:
          return 'Zakończona'
        default:
          return ''
      }
    },
    handleSearch() {
      /*   if(!this.searchDate1 && !this.searchDate2 && !this.searchOnlyIncomming)
         {
           this.error('Nie wybrano przedziału dat.')
           return
         }*/
      this.getSearchVisits()
    },
    refreshPastVisits() {
      visitService
          .GetPastVisits()
          .then(resp => {
            if (
                resp.data != null &&
                resp.data.result != null &&
                resp.data.result.items != null
            ) {
              //this.nearVistists = resp.data.result.items
              this.pastVisits = [];
              resp.data.result.items.forEach(itm => {
                let djStart = dayjs(itm.startTime);
                let djEnd = dayjs(itm.endTime);
                this.pastVisits.push({
                  therapistColor: itm.therapistColor,
                  therapistName: itm.therapistName,
                  clientName: itm.clientName,
                  id: itm.id,
                  blink: false,
                  hours: djStart.format("HH:mm") + " - " + djEnd.format("HH:mm")
                });
              });
            }
          })
          .catch(e => {
            console.log(e)
            this.error("Błąd pobierania przeszłych wizyt");
          });
    },
    refreshBlinkClasses() {
      let scheduleObj = this.$refs.ScheduleObj;
      let allEvents = scheduleObj.getEvents();
      allEvents.forEach(event => {
        var elems = document.querySelectorAll(
            '[data-id="Appointment_' + event.Id + '"]'
        );
        if (elems != null && elems.length > 0) {

          if (event.pacjent_obecny) elems[0].classList.add("blink_me");
          else elems[0].classList.remove("blink_me");
        }
      });
    },
    refreshCurrentVisits() {
      visitService
          .GetCurrentVisits()
          .then(resp => {
            if (
                resp.data != null &&
                resp.data.result != null &&
                resp.data.result.items != null
            ) {
              //this.nearVistists = resp.data.result.items
              this.currentVisits = [];
              let localNoBlink = [...this.noBlinkVisits];
              resp.data.result.items.forEach(itm => {
                let djStart = dayjs(itm.startTime);
                let djEnd = dayjs(itm.endTime);
                let blink = !localNoBlink.find(x => x == itm.id);
                this.currentVisits.push({
                  therapistColor: itm.therapistColor,
                  therapistName: itm.therapistName,
                  clientName: itm.clientName,
                  id: itm.id,
                  blink: blink,
                  hours: djStart.format("HH:mm") + " - " + djEnd.format("HH:mm")
                });
              });
              this.refreshBlinkClasses();
              this.clearBlinkStore();
            }
          })
          .catch(e => {
            console.log(e)
            this.error("Błąd pobierania bieżących wizyt");
          });
    },
    refreshNearVisits() {
      if (this.refreshing) return;
      this.refreshing = true;
      visitService
          .GetNearVisits(8)
          .then(resp => {
            if (
                resp.data != null &&
                resp.data.result != null &&
                resp.data.result.items != null
            ) {
              //this.nearVistists = resp.data.result.items
              this.nearVisits = [];
              resp.data.result.items.forEach(itm => {
                let djStart =
                    dayjs(itm.startTime);
                let djEnd = dayjs(itm.endTime);
                this.nearVisits.push({
                  therapistColor: itm.therapistColor,
                  therapistName: itm.therapistName,
                  clientName: itm.clientName,
                  id: itm.id,
                  blink: false,
                  hours: djStart.format("HH:mm") + " - " + djEnd.format("HH:mm")
                });
              });

              this.refreshing = false;
              this.refreshCurrentVisits();
              this.refreshPastVisits();
            }
          })
          .catch(e => {
            console.log(e)
            this.error("Błąd pobierania najbliższych wizyt");
            this.refreshing = false;
          });
    },
    async refreshData() {

      if(this.fullTherapistList == null) return;
      if(this.fullTherapistList && this.fullTherapistList.length == 0) return;
      let dates = this.$refs.ScheduleObj.ej2Instances.getCurrentViewDates()

      let startDate = dates[0]
      let endDate = dates.length > 1 ?  dates[dates.length - 1] : dates[0]
      let data = {
        startDate: dayjs(startDate).format('DD-MM-YYYY'),
        endDate: dayjs(endDate).format('DD-MM-YYYY'),
        przerwy_urlopy: true,
        placowkaId: this.wybranaPlacowka ? this.wybranaPlacowka.id : 0,
        therapistGroupId: this.selectedTherapistGroup ? this.selectedTherapistGroup.id : 0
      }
      if(this.wybranyTerapeuta && this.wybranyTerapeuta.userId > 0 && this.selectedTherapistGroup == null)
      {
        data['therapistID'] = this.wybranyTerapeuta.userId
      }
      visitService.listVisits(data).then(results => {

        this.getCalendarAdditionalOpenDays(startDate, endDate).then(response => {

          if (response.data != null && response.data.result != null) {
            this.currentAdditionalOpenDays = response.data.result
          } else {
            throw "error pobierania dodatkowych dni otwartych";
          }

          let items = results.data.result.items
          if(results.data && results.data.result && results.data.result.items)
          {
            let processedData = [];
            results.data.result.items.forEach(item=> {
              processedData.push({
                Id: item.id,
                Subject: item.isBlock ? item.blockDescription : item.clientName,
                StartTime: item.startTime,
                EndTime: item.endTime,
                CategoryColor: item.therapistColor,
                Description: item.therapistName,
                therapistID: item.therapistID,
                State: item.status,
                pacjent_obecny: item.pacjent_obecny,
                isBlock: item.isBlock,
                notes: item.notes,
                payuPaid: item.payuPaid,
                normalPaid: item.normalPaid,
                isFromPortal: item.isFromPortal,
                portalStatus: item.portalStatus
              });
            })


            if(this.calCurrentView == 'Day')
            {
              let swieto = items.find(x=>x.therapistID == -9999)
              items = items.filter(f=>f.therapistID != -9999)
              this.handleSuccessData(items)
              if(swieto)
              {
                processedData = processedData.filter(f=>f.therapistID != -9999)

                let i = -1;

                this.therapistsList.forEach(tid => {
                  processedData.push({
                    Id: i,
                    Subject: swieto.isBlock ? swieto.blockDescription : swieto.clientName,
                    StartTime: swieto.startTime,
                    EndTime: swieto.endTime,
                    CategoryColor: swieto.therapistColor,
                    Description: swieto.therapistName,
                    therapistID: tid.therapistID,
                    State: swieto.status,
                    pacjent_obecny: swieto.pacjent_obecny,
                    isBlock: swieto.isBlock,
                    notes: '',
                    payuPaid: false,
                    normalPaid: false
                  });
                  i--;
                })
              }
            }
            else {
              this.handleSuccessData(items)
            }

            this.eventSettings = { dataSource: processedData }

            if(this.calCurrentView == 'Day' || this.wybranyTerapeuta)
            {
              this.allowDragAndDrop = true
            }
            else
            {
              this.allowDragAndDrop = false
            }
          }
        }).catch(()=> {
          this.error("Nie można pobrać dodatkowych dni otwartych");
        })


      }).catch(() => {
        this.error("Błąd pobierania wizyt")
      })

      this.updateSmsStatus()
      this.getAllTypyWizyt()
      this.getReserves()
    },
    closeAddPopup() {
      //this.unsubscribeEvent();
      this.visitData = null;
      this.showVisitEditor = false;
      if(this.searchResultsVisible)
      {
        this.getSearchVisits()
      }
      else
      {
        this.refreshData();
        //this.refreshNearVisits();
      }
    },
    addIcon(elem,icon)
    {      
      if(elem == null) return;
      let iconDiv = document.createElement("div")
      iconDiv.innerHTML = icon
      iconDiv.classList.add("icon")
      elem.appendChild(iconDiv)
    },
    addCloseStyles(elem){

      /*let img = `linear-gradient(45deg, ${color} 33.33%, #e4edf2 33.33%, #e4edf2 50%, ${color} 50%, ${color} 83.33%, #e4edf2 83.33%, #ie4edf2 100%)`
      elem.style.backgroundImage = img
      elem.style.backgroundSize = "21.21px 21.21px"
      elem.style.color = "black"
      elem.style.fontWeight = "bold"*/
      elem.style.opacity = 0.3;
    },
    addConfirmedStyles(elem)
    {
      //icon fa-check
      this.addIcon(elem.querySelector(".icon-row")  ,'<i class="fa fa-check"></i>')
    },
    addPayuStyles(elem)
    {
      //simply U character not icon
      this.addIcon(elem.querySelector(".icon-row")  ,'U')
    },
    addNormalPayStyles(elem)
    {
      this.addIcon(elem.querySelector(".icon-row")  ,'<i class="fas fa-dollar-sign"></i>')
    },
    addNotesStyles(elem)
    {
      this.addIcon(elem.querySelector(".icon-row")  ,'<i class="fa fa-info-circle"></i>')
    },
    addPortalStyles(elem)
    {
      this.addIcon(elem.querySelector(".icon-row")  ,'<i class="fa fa-globe" style="color: #4CAF50;"></i>')
    },
    addPortalPendingStyles(elem)
    {
      // Pending portal visits get prominent pulsing globe icon
      this.addIcon(elem.querySelector(".icon-row")  ,'<i class="fa fa-globe portal-pending-icon" style="color: #FF5722; animation: pulse 1s infinite;"></i>')
      elem.style.border = '2px solid #FF5722';
    },
    addCanceledByUserStyles(elem)
    {
      this.addIcon(elem.querySelector(".icon-row")  ,'<i class="fa fa-user-times"></i>')
    },
    addCancelledVisitStyles(elem)
    {
      //\f06a
      this.addIcon(elem.querySelector(".icon-row")  ,'\f06a')
      elem.style.opacity = 0.3;
    },
    addUnknownResponseStyles(elem)
    {
      //\f059
      this.addIcon(elem.querySelector(".icon-row")  ,'\f059')
    },
    clearCloseStyles(id)
    {
      let elems = document.querySelectorAll(
          '[data-id="Appointment_' + id + '"]'
      );
      if (elems != null && elems.length > 0)
      {
        //    elems[0].style.display = "block";
        elems[0].style.opacity = 1.0;
      }
    },
    noBlinkVisit(visitid) {
      let visit = this.currentVisits.find(x => x.id == visitid);
      if (visit != null) {
        visit.blink = false;

        let localArray = [...this.noBlinkVisits];
        if (!localArray.find(x => x == visitid)) localArray.push(visitid);

        this.saveNoBlinkVisits(localArray);
        this.refreshBlinkClasses();
      }
    },
    blinkVisit(visitid) {
      let visit = this.currentVisits.find(x => x.id == visitid);
      if (visit != null) {
        visit.blink = true;

        let localArray = [...this.noBlinkVisits];
        if (!localArray.find(x => x == visitid)) localArray.push(visitid);

        this.saveNoBlinkVisits(localArray);
        this.refreshBlinkClasses();
      }
    },
    clearBlinkStore() {
      let localArray = [...this.noBlinkVisits];
      let newArray = [];
      localArray.forEach(x => {
        if (this.currentVisits.find(x => x.id == x)) newArray.push(x);
      });
      this.saveNoBlinkVisits(newArray);
    },
    oneventRendered: function(args) {      
      args.element.addEventListener('contextmenu', (event) => {
        if(args.data && args.data.Id)
        {
          this.selectedVisitQuickInfoId = args.data.Id;
          this.showVisitQuickInfo = true;
                    
        }        
        event.preventDefault(); // Prevent default context menu

        // Get the associated event data
        //const eventDetails = this.$refs.ScheduleObj.getEventDetails(args.element);
        //console.log(eventDetails)
      });
      if (
          args != null &&
          args.data != null &&
          args.data.therapistID != null &&
          args.data.therapistID > 0
      ) {
       /* let t = this.localTherapistsList.find(
            x => x.therapistID == args.data.therapistID
        );
        if (t != null && t.checked == false) {
          args.element.style.display = "none";
        }
        else
        {*/
       //console.log(args.element);
          if(args.data.State == 3)
          {

            this.addCloseStyles(args.element,args.data.CategoryColor)
          }
          if(args.data.State == 1)
          {
            this.addConfirmedStyles(args.element)
          }
          if(args.data.State == 4)
          {
            this.addCanceledByUserStyles(args.element)
          }
          if(args.data.State == 2)
          {
            this.addCancelledVisitStyles(args.element)
          }
          if(args.data.State == 5)
          {
            this.addUnknownResponseStyles(args.element)
          }
          if(args.data.payuPaid && this.settings.showPaymentIconInCalendar)
          {
            this.addPayuStyles(args.element)
          }
          if(args.data.normalPaid && this.settings.showPaymentIconInCalendar)
          {
            this.addNormalPayStyles(args.element)
          }
          if(args.data.notes && args.data.notes.length > 0 && this.settings.showNotesIconInCalendar)
          {
            this.addNotesStyles(args.element)
          }
          // Portal visit icons
          if(args.data.isFromPortal)
          {
            // PENDING status (1) gets prominent pulsing icon
            if(args.data.portalStatus === 1)
            {
              this.addPortalPendingStyles(args.element)
            }
            else
            {
              this.addPortalStyles(args.element)
            }
          }
        //}
      }
    },
    onChangeResourceVisibility() {
    },

    handleSuccessData(args) {
      if (args != null) {
        let scheduleObj = this.$refs.ScheduleObj.ej2Instances;
        let renderedDates = scheduleObj.activeView.getRenderDates();

        let localList = []
        if(!this.pokazuj_wszystkich) {
          if(args.length == 0)
          {
            this.dostepniTerapeuci.forEach(item=> {
              let insert = true
              let obj = {
                therapistID: item.id,
                therapistName: item.shortName,
                therapistColor: item.color,
              }
              if(this.calCurrentView == 'Day')
              {

                if(item.schedules)
                {
                  let dayIndex = renderedDates[0].getDay();
                  let schedule = item.schedules.find(x=>x.isEnabled && x.day == dayIndex)
                  if(schedule == null) {
                    insert = false;
                  }

                }
                else
                {
                  insert = false;
                }
              }
              if(insert) {
                localList.push(obj)
              }
              else
              {
                if(this.currentAdditionalOpenDays.length > 0)
                {
                  let elem = this.currentAdditionalOpenDays.find(x=>x.therapistID == item.therapistID)
                  if(elem != null)
                  {
                    localList.push(obj);
                  }
                }
              }
            })
          }
          else {

            args.forEach(item => {

              let obj = {
                therapistID: item.therapistID,
                therapistName: item.therapistName,
                therapistColor: item.therapistColor
              };

              let itm = localList.find(x => x.therapistID == item.therapistID)
              if (!itm) {
                let insert = true
                if(this.calCurrentView == 'Day') {
                  insert = false
                  if(this.dostepniTerapeuci.find(x=>x.id == item.therapistID) == null)
                    insert = true
                }
                if(insert)
                  localList.push(obj)
              }
            });
            this.dostepniTerapeuci.forEach(item=> {
              let insert = false
              let obj = {
                therapistID: item.id,
                therapistName: item.shortName,
                therapistColor: item.color,
              }
              let itm = localList.find(x => x.therapistID == item.id)
              if(this.calCurrentView == 'Day' && itm == null)
              {
                let hasVisits = args.find(x => x.therapistID == item.id && !x.isBlock)
                if(hasVisits) {
                  insert = true
                }
                else if(item.schedules)
                {
                  let dayIndex = renderedDates[0].getDay();
                  let schedule = item.schedules.find(x=>x.isEnabled && x.day == dayIndex)
                  if(schedule == null)
                    insert = false;
                  else
                    insert = true
                }
                else
                {
                  insert = false;
                }
              }
              if(insert) {
                localList.push(obj)
              }
              else
              {
                if(this.currentAdditionalOpenDays.length > 0)
                {
                  let elem = this.currentAdditionalOpenDays.find(x=>x.therapistID == item.therapistID)
                  if(elem != null)
                  {
                    localList.push(obj);
                  }
                }
              }
            })
          }
        }
        if(localList.length == 0 || this.pokazuj_wszystkich) {
            if(this.calCurrentView == 'Day')
            {
              this.dostepniTerapeuci.forEach(item=> {

                let obj = {
                  therapistID: item.id,
                  therapistName: item.shortName,
                  therapistColor: item.color
                }
                localList.push(obj)
              })
            }
        }
        if(this.wybranyTerapeuta != null && this.calCurrentView != 'Day' )
        {
          //localList = []
          let therapist = this.fullTherapistList.find(x=>x.id == this.wybranyTerapeuta.id)
          if(therapist != null)
          {
            let obj = {
              therapistID: therapist.id,
              therapistName: therapist.shortName,
              therapistColor: therapist.color
            }
            localList.push(obj)
          }
        }

        if(this.selectedTherapistGroup != null && this.selectedTherapistGroup.id > 0)
        {
          localList = [];
          let therapists = this.fullTherapistList.filter(x=>x.groupId == this.selectedTherapistGroup.id)
          therapists.forEach(item=> {
            let obj = {
              therapistID: item.id,
              therapistName: item.shortName,
              therapistColor: item.color
            }
            localList.push(obj)
          })
          
        }
        this.therapistsList = localList


      }
    },
    getClientValues(val) {
      this.isLoadingClients = true;
      clientService
          .getAll({ query: val, page: 1, limit: 20, sorting: "surname" })
          .then(data => {
            data.data.result.items.forEach(item => {
              if (!this.clientsList.find(x => x.id === item.id)) {
                let name = item.name + " " + item.surname;
                if (item.pesel != null && item.pesel != "")
                  name = name + "/" + item.pesel;
                this.clientsList.push({
                  id: item.id,
                  name: name,
                  therapist: item.therapistID
                });
              }
            });

            this.isLoadingClients = false;
          })
          .catch(e => {
            console.log(e)
            this.isLoadingClients = false;
            this.error("Nie można pobrać listy klientów.");
          });
    },
    getCalendarAdditionalOpenDays(startDate, endDate)
    {
      return therapistsService.GetCalendarAdditionalOpenDays({start: dayjs(startDate).format('MM-DD-YYYY'), end: dayjs(endDate).format('MM-DD-YYYY'), placowkaId: this.wybranaPlacowka != null ? this.wybranaPlacowka.id : 0});
    },
    getAllTherapists() {

      therapistsService
          .getAll({ query: '', page: 1, limit: 9999, IsActive: true, GetSchedules: true })
          .then(response => {
            if (
                response.data != null &&
                response.data.result != null &&
                response.data.result.items != null
            ) {
              this.fullTherapistList = response.data.result.items
              this.refreshData()
              if(this.settings.forceCalendarToOneTherapist && this.dostepniTerapeuci && this.dostepniTerapeuci.length > 0 && this.wybranyTerapeuta == null)
                this.wybranyTerapeuta = this.dostepniTerapeuci[0]
            } else {
              throw "error pobierania terapeutów";
            }
          })
          .catch(e => {
            console.log(e)
            this.isLoadingTherapists = false;
            this.error("Nie można pobrać listy terapeutów.");
          });
    },
    loadTherapists(val) {
      this.isLoadingTherapists = true;
      therapistsService
          .getAll({ query: val, page: 1, limit: 10 })
          .then(response => {
            if (
                response.data != null &&
                response.data.result != null &&
                response.data.result.items != null
            ) {
              response.data.result.items.forEach(r => {

                if (!this.therapists.find(x => x.id === r.id))
                  this.therapists.push({
                    id: r.id,
                    name: r.name + " " + r.surname,
                    pay: r.rate
                  });
              });
              this.isLoadingTherapists = false;
            } else {
              throw "error pobierania terapeutów";
            }
          })
          .catch(e => {
            console.log(e)
            this.isLoadingTherapists = false;
            this.error("Nie można pobrać listy terapeutów.");
          });
    },
    updateSmsStatus(){
      console.log('updateSmsStatus')
      console.log(this.isSmsEnabled)
      console.log(ability.can('do','POKO_InformacjeSMS'))
      if(this.isSmsEnabled && ability.can('do','POKO_InformacjeSMS'))
      {
        visitService.GetSMSDailyStatus().then(resp=> {
          if(resp.data != null && resp.data.result != null)
          {
            //console.log(resp.data.result)
            //this.lastTimeCheckedSMS =  
            var day = new dayjs(resp.data.result.forDay)
            this.visitsToCheck = resp.data.result.visitsToCheck
            this.smsText =  'Ilość smsów na dzień '+day.format('DD-MM-YYYY')+': '+resp.data.result.smsSent+'/'+resp.data.result.smsTotal;
            if(resp.data.result.lastTimeDeviceChecked != null) {
              var lastTimeChecked = new dayjs(resp.data.result.lastTimeDeviceChecked)
              this.lastTimeCheckedSMS = 'Ostatnia synchronizacja z urządzenia SMS: '+lastTimeChecked.format('DD-MM-YYYY HH:mm')
            }
            // Update unread SMS count
            this.unreadSMSCount = resp.data.result.unreadSMSCount || 0                        
          }
        })
      }
    },
    goToSMSCenter() {
      this.$router.push('/sms-center?onlyUnread=true');
    },
    navigating(args)
    {

      //scheduleObj.dataModule.query.params
      let scheduleObj = document.getElementById("Schedule").ej2_instances[0];

      if(args && args.action == 'view') {

        if (args && args.currentView === 'Day') {
          this.calCurrentView = 'Day'
          this.reserveButtonVisible = true
          scheduleObj.group.resources = ["Terapeuci"];

          //this.refreshData()
          //console.log('day')
        } else {
          this.reserveButtonVisible = false
          this.open_reserves = false
          this.calCurrentView = args.currentView

          scheduleObj.group.resources = [];
          //this.refreshData()
          //console.log('other')

        }
      }
    },
    pokazWolneDaty() {
      //this.selectedDate = this.wolnytermin.toDate()
      this.therapists_visits_schedules = true
    },
    getReserves()
    {
      if( this.calCurrentView == 'Day') {
        let scheduleObj = this.$refs.ScheduleObj.ej2Instances;
        let renderedDates = scheduleObj.activeView.getRenderDates();
        let date = new dayjs(renderedDates[0]).format("YYYY-MM-DD")
        reserveService.getReservesForDay(date).then(result => {
          this.reserves = result.data.result
        })
      }
    },
    getSearchVisits() {
      const { sortBy, sortDesc, page, itemsPerPage  } = this.pagination
      let sortValue = ''
      if(sortBy.length > 0)
      {
        sortValue = sortBy[0]
        if(sortDesc.length > 0)
          sortValue = sortBy[0] + ( sortDesc[0] ? " DESC": "");
      }
      this.searchResultsVisible = true
      this.searchLoading = true
      var data = {}
      data.SkipCount = (page - 1) * itemsPerPage
      data.MaxResultCount = itemsPerPage
      data.Sorting = sortValue
      if(this.searchClientId > 0)
      {
        data.clientID = this.searchClientId
      }
      if(this.searchTherapistId > 0)
      {
        data.therapistID = this.searchTherapistId
      }
      if(this.searchOnlyIncomming)
      {
        data.showOnlyIncommingVisits = true
      }
      else
      {
        data.startDate = this.searchDate1
        data.endDate = this.searchDate2
      }
      visitService.ListPaginatedVisits(data).then(resp => {
        if(resp.data != null && resp.data.result != null)
        {
          this.searchItems = resp.data.result.items,
              this.searchTotalResults = resp.data.result.totalCount
        }
        this.searchLoading = false
      }).catch(e => {
        console.log(e)
        this.error("Błąd wyszukiwania wizyt")
        this.searchLoading = false
      })


    }
  },
  created() {
    this.updateTitle("Wizyty");
    this.getAllTherapists()
    //this.eventSettings.dataSource.adaptor.receivedData = this.handleSuccessData;
    this.updateSmsStatus()
    this.getAllZabiegi()
    // Check for editId query param to open visit editor directly
    if (this.$route.query.editId) {
      this.$nextTick(() => {
        this.showEditPopup(parseInt(this.$route.query.editId));
        // Clean up the URL
        this.$router.replace({ path: "/visits" });
      });
    }
  },
  components: {
    TherapistsVisitsSchedules,
    SearchSMSVisits,
    EditReserve,
    VisitEditor,
    VisitQuickInfo
  },
  provide: {
    schedule: [Day, Week, Month,DragAndDrop]
  },
  mounted() {

    this.timerVisits = setInterval(this.refreshData.bind(this), 5 * 60 * 1000); //odswiezamy dane co 5 min
    //this.timerNear = setInterval(this.refreshNearVisits.bind(this), 60 * 2000); //odswiezamy najblizsze wizyty co 2 min
    Vue.prototype.$timerVisits = this.timerVisits
    // Refresh unread SMS count every 60 seconds
    this.smsRefreshInterval = setInterval(this.updateSmsStatus.bind(this), 60 * 1000);
    //Vue.prototype.$timerNear = this.timerNear
    dayjs.extend(customParseFormat);
    dayjs.extend(isSameOrAfter);
    dayjs.extend(isBetween);
    dayjs.extend(isToday)
    this.getTherapistGroups()
    settingsService.GetCompanySettings().then(success=> {
      if(success.data.result)
      {
        let data = success.data.result
        if(data.id > 0)
        {
          if(data.godzina_otwarcia_start)
          {
            this.startHour = dayjs(data.godzina_otwarcia_start).format('HH:mm')
          }
          if(data.godzina_otwarcia_koniec)
          {
            this.endHour = dayjs(data.godzina_otwarcia_koniec).format('HH:mm')
          }
        }
      }
    }).catch(() => {
      this.error('Bład pobierania ustawień firmy')
    })
    this.getAllTypyWizyt()
    //let startDate = currentViewDates[0]
    //let endDate = currentViewDates[currentViewDates.length - 1]
    //console.log(startDate);
    //console.log(endDate);
    if(this.dostepnePlacowki && this.dostepnePlacowki.length > 0)
    {
      this.wybranaPlacowka = this.dostepnePlacowki[0]
    }

  },
  beforeDestroy() {
    clearInterval(this.timerVisits);
    clearInterval(this.timerNear);
    if (this.smsRefreshInterval) {
      clearInterval(this.smsRefreshInterval);
    }
  },
  watch: {
    slotCount(val)
    {
      this.timeScale = {    enable: true,
        interval: 60,
        slotCount: val,
        majorSlotTemplate: null,
        minorSlotTemplate: null
      }
    },
    clientKeyword(val) {
      if (val) {
        this.getClientValues(val);
      }
    },
    therapistKeyword(val) {
      if (val) {
        this.loadTherapists(val);
      }
    },
    searchOnlyIncomming(val) {
      if(val)
      {
        this.searchDate1 = null
        this.searchDate2 = null
      }
    },
    wybranyTerapeuta() {


      if(!this.wybranyTerapeuta)
      {
        this.wolnytermin_dostepny = false
      }
      else
      {
        this.wolnytermin_dostepny = true
      }
      this.refreshData()
    },
    selectedTherapistGroup() {
      this.refreshData()
    },
    wybranaPlacowka() {
      this.refreshData()
    },
    pagination: {
      handler() {
        if(this.orgPagination == null)
          this.orgPagination = {...this.pagination}
        if(this.searchResultsVisible)
          this.getSearchVisits()
      },
      deep: true
    }
  }
};
</script>

<style>

/* Portal pending visit pulse animation */
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.portal-pending-icon {
  animation: pulse 1s infinite;
}

.visits .e-schedule table.e-schedule-table td {
  padding: initial;
}
.poko-.e-schedule.e-device .e-resource-tree-popup .e-fullrow {
  height: 50px;
}
.e-schedule .e-vertical-view .e-work-cells:not(.e-work-hours)
{
  background-color: #ededed !important;
}
#reserve_button
{
  position: absolute;
  top:0;
  right:0;
  margin-top:100px;
}
.reserve-container
{
  color:white !important;
  padding:10px;
  font-size:10pt;
  position:relative;
  cursor: move;
}
.fa.fa-grip:before {
  content: "\f142 \202F \f142 \202F \f142";
}
.fa.fa-grip-large:before {
  content: "\f142 \202F \f142 \202F \f142 \202F \f142 \202F \f142 \202F \f142 \202F \f142";
}
.e-schedule .e-vertical-view .e-work-cells.hover {
  background: #f5f5f5;
  color: #000;
}

.wrap-text
{
  word-wrap: normal;
  white-space: normal;;
  font-size: 10pt;
}
.inner-container {
  position: relative; /* Needed for absolute positioning of icon row */
  height: 100%;
  width: 100%;
  overflow: hidden; /* Prevent any overflow */
}

.subject-container {
  height: 100%;
  width: 100%;
  overflow: hidden; /* Ensures text never overflows */
}

.subject {
  height: 100%;  
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  /* Your existing subject styles */
}

.icon-row {
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  height: 30px;
  align-items: center;  
  background: inherit;
  z-index: 1; /* Ensures icons appear above content if overlapping */
}

.icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;  
}
</style>
